import * as React from 'react'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { useData, useHandlers } from './hooks'
import { ENTITY_TYPES } from '@sales-center/common'

type Props = { entityId: number; entityType: ENTITY_TYPES; id: number }

export function ActivityDetailsActions(props: Props) {
  const { disableSave, setDisableSave } = useData()
  const { handleCancelClick, handleSaveClick } = useHandlers({
    ...props,
    setDisableSave,
  })

  return (
    <Stack justifyContent="end" spacing={1} direction="row" mt={2}>
      <Button
        size="small"
        fullWidth
        onClick={handleCancelClick}
        data-test-id={`activity-status-cancel-${props.id}`}
      >
        Cancel
      </Button>
      <Button
        disabled={disableSave}
        variant="contained"
        size="small"
        fullWidth
        onClick={handleSaveClick}
        data-test-id={`activity-status-save-${props.id}`}
      >
        Save
      </Button>
    </Stack>
  )
}
